import Vue from 'vue';
import Vuelidate from 'vuelidate';
import i18n from './vue-i18n';

Vue.use(Vuelidate);
Vue.use(i18n);

export default (el = '', component, props = {}) => {
  const init = () => new Vue({
    el,
    propsData: props,
    ...component,
  });

  return {
    init,
  };
};
